/**
 * StepIconsRow - Horizontal row of 3 gradient circular icons with connecting lines
 * Used on the welcome screen to show the 3-step journey: Create/Discover → Stake → Earn
 */

const STEPS = [
  {
    id: 1,
    label: "Create or Join challenges",
    icon: "dasher", // Uses DasherWhite.png
  },
  {
    id: 2,
    label: "Stake your money",
    icon: "dollar", // $ symbol
  },
  {
    id: 3,
    label: "Earn Rewards and flex",
    icon: "medal", // Medal icon
  },
] as const;

export function StepIconsRow() {
  return (
    <div className="flex flex-col gap-3 px-5">
      {/* Icons Row with Connecting Line */}
      <div className="relative w-full h-14">
        {/* Connecting Line - Spans between first and last icon centers */}
        <div
          className="absolute top-1/2 -translate-y-1/2 h-px bg-[#059669] dark:bg-[#13e564]"
          style={{ left: "28px", right: "28px" }}
        />

        {/* Icon 1 - Left */}
        <div className="absolute left-0 top-0 step-icon-circle flex items-center justify-center w-14 h-14 rounded-full">
          <img
            src="/DasherWhite.png"
            alt="Dasher"
            className="w-[38px] h-[38px] object-contain"
            style={{ filter: "drop-shadow(0px 5px 5px rgba(0, 0, 0, 0.25))" }}
          />
        </div>

        {/* Icon 2 - Center */}
        <div className="absolute left-1/2 -translate-x-1/2 top-0 step-icon-circle flex items-center justify-center w-14 h-14 rounded-full">
          <span
            className="text-white text-[32px] font-semibold font-poppins leading-none"
            style={{ textShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)" }}
          >
            $
          </span>
        </div>

        {/* Icon 3 - Right */}
        <div className="absolute right-0 top-0 step-icon-circle flex items-center justify-center w-14 h-14 rounded-full">
          <span
            className="material-symbols-outlined text-white text-[36px]"
            style={{
              fontVariationSettings: "'FILL' 1, 'wght' 400",
              filter: "drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))",
            }}
          >
            military_tech
          </span>
        </div>
      </div>

      {/* Labels Row - Positioned to align with icon centers */}
      <div className="relative w-full h-5">
        {/* Label 1 - Under left icon */}
        <div className="absolute left-0 top-0 w-[90px] -translate-x-[17px] text-center">
          <p className="text-[9.5px] font-semibold text-slate-600 dark:text-[#d7d2d2] leading-[10px] tracking-[-0.02em] font-poppins">
            {STEPS[0].label}
          </p>
        </div>

        {/* Label 2 - Under center icon */}
        <div className="absolute left-1/2 top-0 w-[90px] -translate-x-1/2 text-center">
          <p className="text-[9.5px] font-semibold text-slate-600 dark:text-[#d7d2d2] leading-[10px] tracking-[-0.02em] font-poppins">
            {STEPS[1].label}
          </p>
        </div>

        {/* Label 3 - Under right icon */}
        <div className="absolute right-0 top-0 w-[90px] translate-x-[17px] text-center">
          <p className="text-[9.5px] font-semibold text-slate-600 dark:text-[#d7d2d2] leading-[10px] tracking-[-0.02em] font-poppins">
            {STEPS[2].label}
          </p>
        </div>
      </div>
    </div>
  );
}
